import Vue from 'vue'

export default {
  priceList: {
    update (id, priceList) {
      return Vue.http.put(`api/price_lists/${id}`, priceList)
    },
    get (id) {
      return Vue.http.get(`api/price_lists/${id}`)
    }
  },
  notice: {
    update (id, notice) {
      return Vue.http.put(`api/notices/${id}`, notice)
    },
    get (id) {
      return Vue.http.get(`api/notices/${id}`)
    },
    post (data) {
      return Vue.http.post(`api/notices`, data)
    },
    getList () {
      return Vue.http.get(`api/notices`)
    },
    remove (id) {
      return Vue.http.delete(`api/notices/${id}`)
    }
  },
  product: {
    archive (id) {
      return Vue.http.put(`api/products/${id}`, { archived: true })
    },
    unArchive (id) {
      return Vue.http.put(`api/products/${id}`, { archived: false })
    },
    getList () {
      return Vue.http.get(`api/products`)
    },
    post (data) {
      return Vue.http.post(`api/products`, data)
    },
    updateFeatured (ids) {
      return Vue.http.get(`api/products/action/update_featured`, {
        params: {
          ids
        }
      })
    }
  },
  planDefinition: {
    getList () {
      return Vue.http.get(`api/plan_definitions`)
    }
  },
  payment: {
    getList (search = '') {
      return Vue.http.get(`api/payments?order.user.email=${search}`)
    },
    setAsPaid (id) {
      return Vue.http.get(`api/payments/${id}/set_as_paid`)
    }
  },
  user: {
    getList (search = '', packet = '', type = '') {
      let params = {}
      if (search) {
        params['email'] = search
      }
      if (packet) {
        params['access.name'] = packet
      }
      if (type) {
        params['type'] = type
      }
      const encoded = Object.keys(params).map(k => `${k}=${params[k]}`).join('&')
      return Vue.http.get(`api/users?${encoded}`)
    },
    getItem (id) {
      return Vue.http.get(`api/users/${id}`)
    },
    changePlanDefinition (id, planId, from, to, trial) {
      return Vue.http.get(`api/users/${id}/change_plan_definition/${planId}?from=${from}&to=${to}&trial=${trial}`)
    },
    resendActivation (id) {
      return Vue.http.get(`api/users/${id}/resend/activation`)
    }
  },
  card: {
    get (day, success, error) {
      Vue.http.get(`api/cards/${day}`).then(success, error)
    },
    put (day, card) {
      return Vue.http.put(`api/cards/${day}`, card)
    },
    usePrevious (id) {
      return Vue.http.get(`api/cards/${id}/use_previous`)
    },
    publish (id) {
      return Vue.http.get(`api/cards/${id}/publish`)
    },
    notify (id) {
      return Vue.http.get(`api/cards/${id}/notify`)
    }
  },
  record: {
    update (id, record) {
      return Vue.http.put(`api/records/${id}`, record)
    },
    get (id, success, error) {
      Vue.http.get(`api/records/${id}`).then(success, error)
    }
  },
  producer: {
    moveUp (id) {
      return Vue.http.put(`api/producers/${id}/move_up`)
    },
    moveDown (id) {
      return Vue.http.put(`api/producers/${id}/move_down`)
    },
    post (producer) {
      return Vue.http.post(`api/producers`, producer)
    },
    update (id, record) {
      return Vue.http.put(`api/producers/${id}`, record)
    },
    remove (id) {
      return Vue.http.delete(`api/producers/${id}`)
    },
    get (id) {
      return Vue.http.get(`api/producers/${id}`)
    },
    getList () {
      return Vue.http.get(`api/producers`)
    }
  },
  file: {
    remove (id) {
      return Vue.http.delete(`api/files/${id}`)
    },
    post (data) {
      return Vue.http.post(`api/files`, data)
    },
    getList () {
      return Vue.http.get(`api/files`)
    }
  },
  auth: {
    login (username, password) {
      return Vue.http.post('api/login_check', {
        _username: username,
        _password: password
      })
    }
  },
  homepage: {
    get () {
      return Vue.http.get('api/homepages/1')
    }
  },
  regulation: {
    get () {
      return Vue.http.get('api/regulations/1')
    },
    put (regulation) {
      return Vue.http.put('api/regulations/1', regulation)
    }
  },
  producerList: {
    get () {
      return Vue.http.get('api/producer_lists/1')
    },
    put (producer) {
      return Vue.http.put('api/producer_lists/1', producer)
    }
  },
  contact: {
    get () {
      return Vue.http.get('api/contacts/1')
    },
    put (data) {
      return Vue.http.put('api/contacts/1', data)
    }
  }
}



// WEBPACK FOOTER //
// ./src/api.js